import React from 'react';
import { useLanguage } from '../i18n';

const WhatsAppButton = () => {
  const { t } = useLanguage();
  const message = encodeURIComponent(t.whatsapp.message);

  return (
    <a
      href={`https://wa.me/243895534241?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp.tooltip}
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] shadow-2xl transition-all duration-200 hover:scale-110">
        <svg viewBox="0 0 32 32" fill="white" className="w-8 h-8">
          <path d="M16 .667C7.548.667.667 7.548.667 16c0 2.704.712 5.344 2.064 7.672L.6 31.4l7.912-2.076A15.26 15.26 0 0 0 16 31.333c8.452 0 15.333-6.88 15.333-15.333C31.333 7.548 24.452.667 16 .667zm0 28.086a12.72 12.72 0 0 1-6.488-1.772l-.464-.276-4.696 1.232 1.252-4.58-.304-.472A12.68 12.68 0 0 1 3.245 16C3.245 8.972 8.972 3.245 16 3.245S28.755 8.972 28.755 16 23.028 28.753 16 28.753zm6.996-9.552c-.384-.192-2.268-1.12-2.62-1.248-.352-.128-.608-.192-.864.192-.256.384-.992 1.248-1.216 1.504-.224.256-.448.288-.832.096-.384-.192-1.62-.596-3.084-1.902-1.14-1.016-1.91-2.272-2.134-2.656-.224-.384-.024-.592.168-.782.172-.172.384-.448.576-.672.192-.224.256-.384.384-.64.128-.256.064-.48-.032-.672-.096-.192-.864-2.084-1.184-2.852-.312-.748-.628-.648-.864-.66-.224-.01-.48-.012-.736-.012s-.672.096-1.024.48c-.352.384-1.344 1.312-1.344 3.2s1.376 3.712 1.568 3.968c.192.256 2.708 4.136 6.56 5.8.916.396 1.632.632 2.19.808.92.292 1.756.252 2.418.152.738-.11 2.268-.928 2.588-1.824.32-.896.32-1.664.224-1.824-.096-.16-.352-.256-.736-.448z"/>
        </svg>
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm font-medium px-3 py-2 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-lg">
        {t.whatsapp.tooltip}
      </span>
    </a>
  );
};

export default WhatsAppButton;
